export default {
  TITLE: "ログイン",
  USER_ID: "ユーザーID",
  PASSWORD: "パスワード",
  LOGIN: "ログイン",
  USER_ID_IS_NOT_ENTERED: "ユーザーIDが入力されていません",
  PASSWORD_ID_IS_NOT_ENTERED: "パスワードが入力されていません",
};
